import React from 'react';
import { Container } from 'react-bootstrap';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import Button from '../Button';
import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import ModalFooter from 'react-bootstrap/ModalFooter';
import ModalHeader from './ModalHeader';
import IconButton from '../IconButton';

function ModalDemo({ children }: any) {
  const [showModal1, setShowModal1] = React.useState<boolean>(false);
  const [showModal2, setShowModal2] = React.useState<boolean>(false);
  const [showModal3, setShowModal3] = React.useState<boolean>(false);
  const [showModal4, setShowModal4] = React.useState<boolean>(false);

  const handleShow1 = () => setShowModal1(true);
  const handleClose1 = () => setShowModal1(false);
  const handleShow2 = () => setShowModal2(true);
  const handleClose2 = () => setShowModal2(false);
  const handleShow3 = () => setShowModal3(true);
  const handleClose3 = () => setShowModal3(false);
  const handleShow4 = () => setShowModal4(true);
  const handleClose4 = () => setShowModal4(false);

  const demoBody = () => {
    return (
      <div className="d-flex justify-content-between align-items-center flex-wrap">
        <Button className="mb-3" variant="primary">
          Proceed
        </Button>
        <Button
          className="mb-3"
          variant="primary"
          leftIcon={light('house-blank')}
        >
          Proceed
        </Button>
        <Button
          className="mb-3"
          variant="primary"
          rightIcon={light('house-blank')}
        >
          Proceed
        </Button>
        <Button className="mb-3" variant="primary" size="sm">
          Proceed
        </Button>
        <Button
          className="mb-3"
          variant="primary"
          leftIcon={light('house-blank')}
          size="sm"
        >
          Proceed
        </Button>
        <Button
          className="mb-3"
          variant="primary"
          rightIcon={light('house-blank')}
          size="sm"
        >
          Proceed
        </Button>
      </div>
    );
  };

  return (
    <Container>
      <Container className="mt-10">
        <h4>Modals</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center mt-10">
          <Button variant="primary" onMouseDown={handleShow1}>
            With close button and icon
          </Button>
          <Modal
            show={showModal1}
            onHide={handleClose1}
            dialogClassName="modal-lg"
          >
            <ModalHeader closeButton={true} leftIcon={light('heart-pulse')}>
              <h4 className="text-truncate">Example 1</h4>
            </ModalHeader>
            <ModalBody>{demoBody()}</ModalBody>
            <ModalFooter>
              <Button variant="primary-outline" onMouseDown={handleClose1}>
                Close
              </Button>
            </ModalFooter>
          </Modal>
          <Button variant="primary" onMouseDown={handleShow2}>
            With close button
          </Button>
          <Modal
            show={showModal2}
            onHide={handleClose2}
            dialogClassName="modal-lg"
          >
            <ModalHeader closeButton={true}>
              <h4 className="text-truncate">Example 2</h4>
            </ModalHeader>
            <ModalBody>{demoBody()}</ModalBody>
            <ModalFooter>
              <Button variant="primary-outline" onMouseDown={handleClose2}>
                Close
              </Button>
            </ModalFooter>
          </Modal>
          <Button variant="primary" onMouseDown={handleShow3}>
            No close button
          </Button>
          <Modal
            show={showModal3}
            onHide={handleClose3}
            dialogClassName="modal-lg"
          >
            <ModalHeader closeButton={false}>
              <h4>Example 3</h4>
            </ModalHeader>
            <ModalBody>
              {demoBody()}
              {demoBody()}
              {demoBody()}
              {demoBody()}
              {demoBody()}
            </ModalBody>
            <ModalFooter>
              <Button variant="primary-outline" onMouseDown={handleClose3}>
                Close
              </Button>
              <Button variant="primary" onMouseDown={handleClose3}>
                Proceed
              </Button>
            </ModalFooter>
          </Modal>
          <Button variant="primary" onMouseDown={handleShow4}>
            No close button with icons
          </Button>
          <Modal show={showModal4} onHide={handleClose4}>
            <ModalHeader
              closeButton={false}
              leftIcon={light('heart-pulse')}
              leftIconVariant="icon-emphasized"
              leftIconTooltipPos="top"
              leftIconTooltipText="Hi, this is a tooltip"
              rightButton={
                <IconButton variant="icon-default" icon={light('ellipsis')} extLabel='Benefit Info'/>
              }
            >
              <h4>Example 4</h4>
            </ModalHeader>
            <ModalBody>
              {demoBody()}
              {demoBody()}
              {demoBody()}
              {demoBody()}
              {demoBody()}
            </ModalBody>
            <ModalFooter>
              <Button variant="primary-outline" onMouseDown={handleClose4}>
                Close
              </Button>
              <Button variant="primary" onMouseDown={handleClose4}>
                Proceed
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </Container>
    </Container>
  );
}

export default ModalDemo;
